module.exports = __webpack_public_path__ + "4fb0f6de7be99caf808ec23951fd9b6c.png";